import { loginRequest } from "../authConfig";
import { isPWAInstalled } from "../utils";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { useCallback } from "react";

const useAuthLoginFlow = () => {
  const { instance } = useMsal();
  const dispatch = useDispatch();

  const handleLoginClick = useCallback(() => {
    if (isPWAInstalled()) {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.error(e);
      });
    } else {
      instance.loginPopup(loginRequest).catch((e) => {
        console.error(e);
      });
    }
  }, [dispatch, instance]);
  return {
    handleLoginClick,
  };
};

export default useAuthLoginFlow;